import { useT } from "@/i18n";
import { CanvasReplay } from "./CanvasReplay";
import { AnswerLine, EmptyState, ReadOnlyCard, Section } from "./ReadOnlyKit";
import type { ReadOnlyTemplateProps } from "./types";

/**
 * A past canvas play, replayed with the live canvas renderers: the slide as the student saw it,
 * their answers in place and frozen, every correct answer revealed. Sub-quizzes are separate
 * full-screen questions rather than canvas elements, so they are listed below it.
 */
export function FreeformCanvasReadOnly({
  snapshot,
  response,
  score,
}: ReadOnlyTemplateProps<"freeformCanvas">) {
  const t = useT();
  const { subQuizzes } = snapshot.slideData;

  return (
    <ReadOnlyCard title={snapshot.name} score={score}>
      {snapshot.elements.length === 0 ? (
        <EmptyState message={t["readonly.noCanvasAnswers"]} />
      ) : (
        <CanvasReplay elements={snapshot.elements} answers={response.answers} />
      )}

      {response.quizzes.length > 0 && (
        <Section label={t["readonly.quiz"]}>
          {response.quizzes.map((quiz) => (
            <AnswerLine
              key={quiz.id}
              label={subQuizzes.find((subQuiz) => subQuiz.id === quiz.id)?.question}
              studentAnswer={quiz.answer}
              correctAnswer={subQuizzes.find((subQuiz) => subQuiz.id === quiz.id)?.correctAnswer}
              isCorrect={quiz.isCorrect}
            />
          ))}
        </Section>
      )}
    </ReadOnlyCard>
  );
}
